import { render } from "./CardAdditionComponent.vue?vue&type=template&id=5cf52524&scoped=true"
import script from "./CardAdditionComponent.vue?vue&type=script&lang=js"
export * from "./CardAdditionComponent.vue?vue&type=script&lang=js"

import "./CardAdditionComponent.vue?vue&type=style&index=0&id=5cf52524&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf52524"]])

export default __exports__